import { normalizeSelectValue } from '../../model/normalize-select-value';
import { OptionType } from '../../model/types';
import { WarrantyClaimNoteStatusValues } from 'entities/warranty';
import { FC } from 'react';
import { Select } from 'shared';

type Props = {
  placeholder?: string;
  statuses?: number[];
  onChange: (statuses?: number[]) => void;
  isClearable: boolean;
  isMulti: boolean;
};

export const SelectStatus: FC<Props> = ({ placeholder, statuses, onChange, isClearable, isMulti }) => {
  const options: OptionType[] = WarrantyClaimNoteStatusValues.map((x) => ({
    label: x.label,
    value: x.value!.toString()
  }));

  const selectedIds = statuses ?? [];
  const selectedOptions: OptionType[] = options.filter((option) => selectedIds.includes(Number(option.value)));

  return (
    <Select
      isMulti={isMulti}
      options={options}
      value={selectedOptions}
      onChange={(val) => onChange(normalizeSelectValue(val, isMulti))}
      placeholder={placeholder ?? ''}
      isClearable={isClearable}
      isDisabled={false}
      instanceId={`SelectStatus-select`}
      highlightSelected
      isSolid
    />
  );
};
